import React from "react";
import "./styles.less";
import { Button } from "../../components/Button";
import { useTranslation } from "react-i18next";
import { CommonCode } from "../../blocks/common-code";

export const MainCode = () => {
  const { t } = useTranslation();

  const list = [
    {
      name: "Java",
      imgurl: "//files.authing.co/authing-website/logo-java.svg",
      link: "//docs.authing.cn/v2/reference/sdk-for-java/",
    },
    {
      name: "Python",
      imgurl: "//files.authing.co/authing-website/logo-python.svg",
      link: "//docs.authing.cn/v2/reference/sdk-for-python/",
    },
    {
      name: "Node.js",
      imgurl: "//files.authing.co/authing-website/logo-node.svg",
      link: "//docs.authing.cn/v2/reference/sdk-for-node/",
    },
    {
      name: "iOS",
      imgurl: "//files.authing.co/authing-website/logo-ios.svg",
      link: "//docs.authing.cn/v2/reference/sdk-for-swift.html",
    },
    {
      name: "React",
      imgurl: "//files.authing.co/authing-website/logo-react.svg",
      link: "https://docs.authing.cn/v2/reference/sdk-for-react-native.html",
    },
    {
      name: "C#",
      imgurl: "//files.authing.co/authing-website/logo-c.png",
      link: "//docs.authing.cn/v2/reference/sdk-for-csharp/",
    },
    {
      name: "GO",
      imgurl: "//files.authing.co/authing-website/logo-go.svg",
      link: "https://docs.authing.cn/v2/reference/sdk-for-go/",
    },
    {
      name: "JS",
      imgurl: "//files.authing.co/authing-website/logo-js.svg",
      link: "//docs.authing.cn/v2/reference/sdk-for-node/",
    },
    {
      name: "Ruby",
      imgurl: "//files.authing.co/authing-website/logo-ruby.svg",
      link: "https://docs.authing.cn/v2/reference/sdk-for-ruby.html",
    },
  ];

  const gotoDoc = (item) => {
    window.open(item.link);
  };

  return (
    <div className="code">
      <div className="inner">
        <div key="1" className="top">
          <div className="headline">{t("page.code.title")}</div>
          <div className="subline">{t("page.code.subtitle")}</div>
        </div>
        <div key="2">
          <CommonCode />
        </div>
        <div key="3" className="language-warp">
          <div className="language-title">{t("page.code.other")}</div>
          <div className="language-logos">
            <div className="scroll-mask"></div>
            <div className="scroll-container">
              {list.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="item"
                    onClick={() => gotoDoc(item)}
                  >
                    <div className="logo">
                      <img src={item.imgurl} alt={item.name} />
                    </div>
                    <div className="name">{item.name}</div>
                  </div>
                );
              })}
              {/* 为了循环滚动 */}
              {list.map((item, index) => {
                return (
                  <div
                    key={`${index}-copy`}
                    className="item"
                    onClick={() => gotoDoc(item)}
                  >
                    <div className="logo">
                      <img src={item.imgurl} alt={item.name} />
                    </div>
                    <div className="name">{item.name}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div key="4" className="button-warp">
          <Button
            onClick={() => {
              window.open("https://docs.authing.cn/");
            }}
          >
            {t("common.button.develop-community")}
          </Button>
        </div>
      </div>
    </div>
  );
};
